const nationals = {
  1: 'nswisa',
  2: 'dsa',
  3: 'kanga',
  4: 'unisyd',
  5: 'broome',
  6: 'fencing',
  8: 'kosovo',
  // 9: 'oztag',
  10: 'fencingnsw',
  11: 'utas',
  12: 'handball',
  14: 'gridiron',
  15: 'archery',
  16: 'creadapticvolleyball',
  17: 'auckland',
};

const errormsg = {
  phone: 'Please enter a valid number',
  emails: 'Please enter valid emails',
  email: 'Please enter a valid email',
  password: 'Password must be at least 8 characters with uppercase letters, lowercase letters and special characters.',
  georgianPassword: 'Password must be at least 8 characters and special characters.',
  select_option: 'Please select an option',
  input_option: 'Field is required',
  gte_age: 'Age to must be at least equal to age from',
  age_gte: 'Age to must be at least equal to age from',
  // TODO camel case change needed
  draw_competitionpublished: 'Draw for this competition has already been published',
  draw_compnovenue: 'Compeititon has no venue',
  draw_alreadybuilt: 'Draw for this competition already exists',
  draw_matches: 'Matches already exist for this competition',
  draw_notenoughteam: '3 or more teams are required',
  draw_notenoughteam_in_pools: '3 or more teams are required in pools',
  draw_missingroundate: 'Please complete all round dates',
  draw_finalneedmoreteam: 'Not enough teams for the finals template selected',
  draw_invalidrounddatetime: 'Invalid round date',
  draw_sameteam: 'Home & Away team cannot be the same, except TBA',
  draw_tbabyematch: 'Home & Away team cannot be TBA and BYE at the same time',
  two_week_ranges: 'The period should not be longer than 2 weeks',
  one_week_ranges: 'The period should not be longer than 7 days',
  image_format: 'Please upload jpg, png, jpeg files only',
  file_size: 'File size too big, max 5mb',
  indv_draw_competitionpublished: 'Draw for this competition has already been published',
  indv_draw_compnovenue: 'Compeititon has no venue',
  indv_draw_alreadybuilt: 'Draw for this competition already exists',
  indv_draw_matches: 'Matches already exist for this competition',
  indv_draw_notenoughteam: '3 or more teams are required',
  indv_draw_notenoughteam_in_pools: '3 or more teams are required in pools',
  indv_draw_missingroundate: 'Please complete all round dates',
  indv_draw_finalneedmoreteam: 'Not enough teams for the finals template selected',
  indv_draw_invalidrounddatetime: 'Invalid round date',
  indv_draw_sameteam: 'Home & Away team cannot be the same, except TBA',
  indv_draw_tbabyematch: 'Home & Away team cannot be TBA and BYE at the same time',
};

const resultTypes = [
  {
    type: 'pass-fail',
    label: 'Pass/Fail'
  },
  {
    type: 'score',
    label: 'Score'
  },
  {
    type: 'place',
    label: 'Place'
  }];

const productTypes = [
  {
    name: 'Individual',
    type: 'indv'
  },
  {
    name: 'Team',
    type: 'team'
  },
  {
    name: 'Individual To Team',
    type: 'indv-to-team'
  },
  {
    name: 'Entity',
    type: 'entity'
  },
  {
    name: 'Family',
    type: 'family'
  }
];

const entityTypes = [
  {
    name: 'National',
    type: 'national',
    value: 2,
  },
  {
    name: 'State',
    type: 'state',
    value: 3,
  },
  {
    name: 'Association',
    type: 'association',
    value: 4,
  },
  {
    name: 'Club',
    type: 'club',
    value: 5,
  },
  {
    name: 'Team',
    type: 'team',
    value: 6,
  }
];

const genders = [
  'Male',
  'Female',
  'Other',
];

const statuses = [
  {
    name: 'Open',
    type: true
  },
  {
    name: 'Closed',
    type: false
  }
];

const yesNoOptions = [
  {
    name: 'Yes',
    type: true,
  },
  {
    name: 'No',
    type: false,
  }
];

// Additional question types
const additionalQTypes = [
  {
    name: 'Input',
    type: 1
  },
  {
    name: 'Dropdown',
    type: 2
  },
  {
    name: 'File Upload',
    type: 3,
  },

  /* -- National Special Types -- */
  // NSWISA PPC Form
  {
    name: 'PPC Form',
    type: 1001,
    nationalIds: [1]
  }
];

// Saleable Item types
const saleableItemTypes = [
  {
    name: 'Shirt',
    type: 1
  },
  {
    name: 'Other',
    type: 0
  },
];

// date range discount types
const discountTypes = [{
  name: '$',
  type: 'dollar'
}, {
  name: '%',
  type: 'percentage'
}];

const emailTemplateTypes = [
  {
    name: 'Appointment Pending',
    path: 'appointments/appointmentPending',
    type: 'system',
    module: 'appointment',
  },
  {
    name: 'Appointment Response',
    path: 'appointments/appointmentResponse',
    type: 'system',
    module: 'appointment',
  },
  {
    name: 'Booking Confirmation',
    path: 'booking/confirmation',
    type: 'system',
    module: 'booking',
  },
  {
    name: 'Refund Successful',
    path: 'booking/refund-successful',
    type: 'system',
    module: 'booking',
  },
  {
    name: 'Discount Code Notification',
    path: 'notifications/discount-code',
    type: 'system',
    module: 'notifications',
  },
  {
    name: 'Reset Password',
    path: 'password/reset-password',
    type: 'system',
    module: 'password',
  },
  {
    name: 'New Password',
    path: 'password/new-password-success',
    type: 'system',
    module: 'password',
  },
  {
    name: 'Change Password',
    path: 'password/change-password-success',
    type: 'system',
    module: 'password',
  },
  {
    name: 'Successful + Receipt',
    path: 'quick-registration/successful',
    type: 'system',
    module: 'quick-rego',
  },
  {
    name: 'Entity Registration Receipt',
    path: 'registration/entity-registration-receipt',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Event Team Registration Pay After',
    path: 'registration/event-team-registration-receipt-pay-after',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Event Team Registration Receipt',
    path: 'registration/event-team-registration-receipt',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Member Registration',
    path: 'registration/member-registration',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Player Registration',
    path: 'registration/player-registration',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Registration No Pay',
    path: 'registration/registration-no-pay',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Registration Receipt',
    path: 'registration/registration-receipt',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Registration Notify Coach',
    path: 'registration/registration-successful-notify-coaches',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Registration Successful',
    path: 'registration/registration-successful',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Registration Clearances',
    path: 'registration/rego-clearances',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Registration Clearance Notify Admin',
    path: 'registration/rego-clearances-notify-admin',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Verification Code',
    path: 'registration/verification-code',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Entity Membership Notification',
    path: 'entity-membership-notification',
    type: 'system',
    module: 'communication',
  },
  {
    name: 'Member Deregistration',
    path: 'member-deregister',
    type: 'system',
    module: 'communication',
  },
  {
    name: 'Membership Expired',
    path: 'ms-expired',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Membership Expiry',
    path: 'ms-expiry',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Member Unlinking',
    path: 'member-unlinked',
    type: 'system',
    module: 'communication',
  },
  {
    name: 'Payment Transfer Failed',
    path: 'payment-transfer-failed',
    type: 'system',
    module: 'communication',
  },
  {
    name: 'Removed From Team',
    path: 'removed-from-team',
    type: 'system',
    module: 'communication',
  },
  {
    name: 'Team Deregistration',
    path: 'team-deregister',
    type: 'system',
    module: 'communication',
  },
  {
    name: 'Team Registration Notification',
    path: 'notifications/team-registration',
    type: 'system',
    module: 'communication',
  },
  {
    name: 'Users Role Assigned',
    path: 'users/users-role-assigned',
    type: 'system',
    module: 'users',
  },
  {
    name: 'Team Registration Confirmation',
    path: 'registration/team-registration-confirmation',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Upcoming Matches',
    path: 'upcoming-matches',
    type: 'system',
    module: 'communication',
  },
  {
    name: 'Registration Status Update',
    path: 'registration/registration-status-update',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Registration Awaiting Approval',
    path: 'registration/admin-registration-notification',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Refund Registration',
    path: 'refund',
    type: 'system',
    module: 'registration',
  },
  {
    name: 'Refund Saleable Items',
    path: 'refund-saleable-items',
    type: 'system',
    module: 'saleable-item',
  },
];

// File upload accepts
const fileUploadAccepts = [
  'image/apng',
  'image/bmp',
  'image/gif',
  'image/jpeg',
  'image/pjpeg',
  'image/png',
  'image/svg+xml',
  'image/tiff',
  'image/webp',
  'image/x-icon',
  'text/plain',
  'audio/flac',
  'audio/mpegurl',
  'audio/mpegurl',
  'audio/x-m4a',
  'audio/m4a',
  'audio/mp4',
  'audio/mp4',
  'audio/mpeg',
  'audio/ogg',
  'audio/ogg',
  'audio/x-scpls',
  'audio/wav',
  'audio/aac',
  'application/json',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/css',
  'text/csv',
  'text/html',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/xml',
  'text/xml',
  'application/pdf',
];

const fileUploadAcceptString = fileUploadAccepts.join(',');

const matchStatus = () => {
  let rs = [
    { value: 'pre-game', label: 'Pre-Game' },
    { value: 'final', label: 'Final' },
    { value: 'forfeit', label: 'Forfeit' },
    { value: 'disputed', label: 'Disputed' },
    { value: 'washout', label: 'Washout' },
  ];

  // eslint-disable-next-line eqeqeq
  if (+process.env.VUE_APP_NATIONAL_ID === 1) {
    rs = rs.concat([
      { value: 'first-quarter', label: 'First Quarter' },
      { value: 'second-quarter', label: 'Second Quarter' },
      { value: 'third-quarter', label: 'Third Quarter' },
      { value: 'fourth-quarter', label: 'Fourth Quarter' },
    ]);
  } else if (+process.env.VUE_APP_NATIONAL_ID === 5) {
    rs = rs.concat([
      { value: 'first-period', label: 'First Period' },
      { value: 'second-period', label: 'Second Period' },
      { value: 'third-period', label: 'Third Period' },
    ]);
  } else if (+process.env.VUE_APP_NATIONAL_ID === 8) {
    rs = rs.concat([
      { value: 'first-half', label: 'First Half' },
      { value: 'half-time', label: 'Half Time' },
      { value: 'second-half', label: 'Second Half' },
      { value: 'final', label: 'Full Time' },
      { value: 'extra-time-1', label: 'Extra Time 1' },
      { value: 'extra-time-2', label: 'Extra Time 2' },
      { value: 'penalty-shootout', label: 'Penalty Shootout' },
    ]);
  } else {
    rs = rs.concat([
      { value: 'first-half', label: 'First Half' },
      { value: 'second-half', label: 'Second Half' },
    ]);
  }
  return rs;
};

const generateMatches = (number, displayName, matchUp) => {
  const matches = [];

  for (let i = 1; i <= number; i++) {
    matches.push({
      match: i, type: 'Final', number: i, displayName, matchUp
    });
  }

  return matches;
};
let seasons = [
  { value: 2020, default: false, label: '2020' },
  { value: 2021, default: false, label: '2021' },
  { value: 2022, default: false, label: '2022' },
  { value: 2023, default: false, label: '2023' },
  { value: 2024, default: false, label: '2024' },
  { value: 2025, default: true, label: '2025' },
];

if (+process.env.VUE_APP_NATIONAL_ID === 8) {
  seasons = [
    { value: 2020, default: false, label: '2020-2021' },
    { value: 2021, default: false, label: '2021-2022' },
    { value: 2022, default: false, label: '2022-2023' },
    { value: 2023, default: false, label: '2023-2024' },
    { value: 2024, default: true, label: '2024-2025' },
  ];
}

if (+process.env.VUE_APP_NATIONAL_ID === 17) {
  seasons = [
    { value: 2020, default: false, label: '2020' },
    { value: 2021, default: false, label: '2021' },
    { value: 2022, default: false, label: '2022' },
    { value: 2023, default: false, label: '2023' },
    { value: 2024, default: false, label: '2024' },
    { value: 2025, default: true, label: '2025' },
  ];
}

let defaultSeason = 2025;

if (+process.env.VUE_APP_NATIONAL_ID === 17) {
  defaultSeason = 2025;
}

const finalTemplates = [
  {
    type: '2 Team 1 Week',
    noOfTeams: 2,
    matches: [
      {
        match: 1, type: 'Final', number: 1, displayName: 'Grand Final', matchUp: '1 v 2'
      }
    ]
  },
  {
    type: '2 Semi 1 Final',
    noOfTeams: 2,
    matches: [
      {
        match: 1, type: 'Final', number: 1, displayName: 'Semi Final', matchUp: '1 v 4'
      },
      {
        match: 2, type: 'Final', number: 1, displayName: 'Semi Final', matchUp: '2 v 3'
      },
      {
        match: 1, type: 'Final', number: 2, displayName: 'Final', matchUp: 'Winner of  SF 1 v and SF 2'
      },
    ]
  },
  {
    type: '2 Knock out 2 Final',
    noOfTeams: 2,
    matches: [
      {
        match: 1, type: 'Final', number: 1, displayName: 'Knock out Round', matchUp: '1 v 2'
      },
      {
        match: 2, type: 'Final', number: 1, displayName: 'Knock out Round', matchUp: '3 v 4'
      },
      {
        match: 1, type: 'Final', number: 2, displayName: 'Final', matchUp: 'Winners of 1 v 2 vs Winners of 3 v 4'
      },
      {
        match: 2, type: 'Final', number: 2, displayName: 'Final', matchUp: 'Loses of 1 v 2 vs Loses of 3 v 4'
      },
    ]
  },
  {
    type: 'Final Template 1 - Top 5',
    noOfTeams: 2,
    matches: [
      {
        match: 1, type: 'Final', number: 1, displayName: 'Week 1', matchUp: '4 v 5'
      },
      {
        match: 2, type: 'Final', number: 1, displayName: 'Week 1', matchUp: '2 v 3'
      },
      {
        match: 3, type: 'Final', number: 2, displayName: 'Week 2', matchUp: '1 v winner of 2v3'
      },
      {
        match: 4, type: 'Final', number: 2, displayName: 'Week 2', matchUp: 'Loser of 2 v 3 and winner of 4 v 5'
      },
      {
        match: 5, type: 'Final', number: 3, displayName: 'Week 3', matchUp: 'Loser of 1 v 2v3 (winner) and winner of 2 v 3 (loser) and of 4 v 5'
      },
      {
        match: 6, type: 'Final', number: 4, displayName: 'Week 4', matchUp: 'Grand Final'
      }
    ]
  },
  {
    type: 'Knockout Template 128 v 128',
    noOfTeams: 128,
    matches: generateMatches(128, 'Knockout 128 v 128', '128 v 128')
  },
  {
    type: 'Knockout Template 64 v 64',
    noOfTeams: 64,
    matches: generateMatches(64, 'Knockout 64 v 64', '64 v 64')
  },
  {
    type: 'Knockout Template 32 v 32',
    noOfTeams: 32,
    matches: generateMatches(32, 'Knockout 32 v 32', '128 v 32')
  },
  {
    type: 'Knockout Template 16 v 16',
    noOfTeams: 16,
    matches: generateMatches(16, 'Knockout 16 v 16', '16 v 16')
  },
  {
    type: 'Knockout Template 8 v 8',
    noOfTeams: 8,
    matches: generateMatches(8, 'Knockout 8 v 8', '8 v 8')
  },
  {
    type: 'Knockout Template 4 v 4',
    noOfTeams: 4,
    matches: generateMatches(4, 'Knockout 4 v 4', '4 v 4')
  },
  {
    type: 'Knockout Template 2 v 2',
    noOfTeams: 2,
    matches: generateMatches(2, 'Knockout 2 v 2', '2 v 2')
  },
];

const uploadURL = `${process.env.VUE_APP_API_URL}/assemble/api/v1/admin/logos/upload`;

const countries = [
  'Unspecified',
  'Australia',
  'New Zealand',
  'Afghanistan',
  'Åland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, The Democratic Republic of the',
  'Cook Islands',
  'Costa Rica',
  'Cote D\'Ivoire',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'England',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and Mcdonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran, Islamic Republic Of',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kosovo',
  'Korea, Democratic People\'s Republic of',
  'Korea, Republic of',
  'Kuwait',
  'Kyrgyzstan',
  'Lao People\'s Democratic Republic',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia, The Former Yugoslav Republic of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova, Republic of',
  'Monaco',
  'Mongolia',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestinian Territory, Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russian Federation',
  'RWANDA',
  'Saint Helena',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Scotland',
  'Senegal',
  'Serbia and Montenegro',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Surilabel',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United States',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Viet Nam',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Wales',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
].map((x) => ({ label: x, value: x }));

const states = [
  'New South Wales',
  'Queensland',
  'South Australia',
  'Tasmania',
  'Victoria',
  'Western Australia',
  'Australian Capital Territory',
  'Northern Territory'
].map((x) => ({ label: x, value: x }));

const positionTypes = [
  { value: 'line-up', label: 'Line up' },
  { value: 'substitute', label: 'Substitute' }
];

const indvCompetitionTypes = [
  { value: 'single', label: 'Individual', noOfMembers: 1 },
  { value: 'double', label: 'Double (2v2)', noOfMembers: 2 },
  { value: 'triple', label: 'Triple (3v3)', noOfMembers: 3 }
];

// Floorball
const posisitonPresets = [{
  label: '9 players- 6 line-ups- 3 substitutes',
  positions: [
    {
      name: 'Goalkeeper',
      abbreviation: 'GK',
      number: '1',
      order: 1,
      type: 'line-up',
      coordinate: {
        x: 45,
        y: 78
      },
      assignedEvent: {
        name: 'Goal',
        type: 1,
        value: 1
      }
    },
    {
      name: 'Left Defender',
      abbreviation: 'LB',
      number: '2',
      order: 2,
      type: 'line-up',
      coordinate: {
        x: 8,
        y: 60
      },
      assignedEvent: {
        name: 'Goal',
        type: 1,
        value: 1
      }

    },
    {
      name: 'Right Defender',
      abbreviation: 'RB',
      number: '3',
      order: 3,
      type: 'line-up',
      coordinate: {
        x: 75,
        y: 60
      },
      assignedEvent: {
        name: 'Goal',
        type: 1,
        value: 1
      }

    },
    {
      name: 'Midfielder',
      abbreviation: 'CM',
      number: '4',
      order: 4,
      type: 'line-up',
      coordinate: {
        x: 45,
        y: 47
      },
      assignedEvent: {
        name: 'Goal',
        type: 1,
        value: 1
      }

    },
    {
      name: 'Left Winger',
      abbreviation: 'LW',
      number: '5',
      order: 5,
      type: 'line-up',
      coordinate: {
        x: 8,
        y: 30
      },
      assignedEvent: {
        name: 'Goal',
        type: 1,
        value: 1
      }

    },
    {
      name: 'Right Winger',
      abbreviation: 'RW',
      number: '6',
      order: 6,
      type: 'line-up',
      coordinate: {
        x: 75,
        y: 30
      },
      assignedEvent: {
        name: 'Goal',
        type: 1,
        value: 1
      }

    },
    // 3 types substitutes
    {
      name: 'Left Sub',
      abbreviation: 'LS',
      number: '7',
      order: 7,
      type: 'substitute',
      assignedEvent: {
        name: 'Goal',
        type: 1,
        value: 1
      }
    },
    {
      name: 'Right Sub',
      abbreviation: 'RS',
      number: '8',
      order: 8,
      type: 'substitute',
      assignedEvent: {
        name: 'Goal',
        type: 1,
        value: 1
      }
    },
    {
      name: 'Center Sub',
      abbreviation: 'CS',
      number: '9',
      order: 9,
      type: 'substitute',
      assignedEvent: {
        name: 'Goal',
        type: 1,
        value: 1
      }
    },

  ]
},
{
  label: 'Basketball',
  positions: [
    {
      name: 'Centre',
      abbreviation: 'C',
      number: '1',
      order: 1,
      type: 'line-up',
    },
    {
      name: 'Power Forward',
      abbreviation: 'PF',
      number: '2',
      order: 2,
      type: 'line-up',
    },
    {
      name: 'Small Forward',
      abbreviation: 'SF',
      number: '3',
      order: 3,
      type: 'line-up',
    },
    {
      name: 'Shooting Guard',
      abbreviation: 'SG',
      number: '4',
      order: 4,
      type: 'line-up',
    },
    {
      name: 'Point Guard',
      abbreviation: 'PG',
      number: '5',
      order: 5,
      type: 'line-up',
    },
    {
      name: '1st Bench',
      abbreviation: '1B',
      number: '6',
      order: 6,
      type: 'substitute',
    },
    {
      name: '2nd Bench',
      abbreviation: '2B',
      number: '7',
      order: 7,
      type: 'substitute',
    },
    {
      name: '3rd Bench',
      abbreviation: '3B',
      number: '8',
      order: 8,
      type: 'substitute',
    },
    {
      name: '4th Bench',
      abbreviation: '4B',
      number: '9',
      order: 9,
      type: 'substitute',
    },
    {
      name: '5th Bench',
      abbreviation: '5B',
      number: '10',
      order: 10,
      type: 'substitute',
    },
    {
      name: '6th Bench',
      abbreviation: '6B',
      number: '11',
      order: 11,
      type: 'substitute',
    },
    {
      name: '7th Bench',
      abbreviation: '7B',
      number: '12',
      order: 12,
      type: 'substitute',
    },
    {
      name: '8th Bench',
      abbreviation: '8B',
      number: '13',
      order: 13,
      type: 'substitute',
    },
    {
      name: '9th Bench',
      abbreviation: '9B',
      number: '14',
      order: 14,
      type: 'substitute',
    },
  ]
},
{
  label: 'Soccer',
  positions: [
    {
      name: 'Goal Keeper',
      abbreviation: 'GK',
      number: '1',
      order: 1,
      type: 'line-up',
    },
    {
      name: 'Defender',
      abbreviation: 'DEF',
      number: '2',
      order: 2,
      type: 'line-up',
    },
    {
      name: 'Defender',
      abbreviation: 'DEF',
      number: '3',
      order: 3,
      type: 'line-up',
    },
    {
      name: 'Defender',
      abbreviation: 'DEF',
      number: '4',
      order: 4,
      type: 'line-up',
    },
    {
      name: 'Defender',
      abbreviation: 'DEF',
      number: '5',
      order: 5,
      type: 'line-up',
    },
    {
      name: 'Midfielder',
      abbreviation: 'MID',
      number: '6',
      order: 6,
      type: 'line-up',
    },
    {
      name: 'Midfielder',
      abbreviation: 'MID',
      number: '7',
      order: 7,
      type: 'line-up',
    },
    {
      name: 'Midfielder',
      abbreviation: 'MID',
      number: '8',
      order: 8,
      type: 'line-up',
    },
    {
      name: 'Midfielder',
      abbreviation: 'MID',
      number: '9',
      order: 9,
      type: 'line-up',
    },
    {
      name: 'Forward',
      abbreviation: 'FWD',
      number: '10',
      order: 10,
      type: 'line-up',
    },
    {
      name: 'Forward',
      abbreviation: 'FWD',
      number: '11',
      order: 11,
      type: 'line-up',
    },
    {
      name: '1st Bench',
      abbreviation: '1B',
      number: '12',
      order: 12,
      type: 'substitute',
    },
    {
      name: '2nd Bench',
      abbreviation: '2B',
      number: '13',
      order: 13,
      type: 'substitute',
    },
    {
      name: '3rd Bench',
      abbreviation: '3B',
      number: '14',
      order: 14,
      type: 'substitute',
    },
    {
      name: '4th Bench',
      abbreviation: '4B',
      number: '15',
      order: 15,
      type: 'substitute',
    },
    {
      name: '5th Bench',
      abbreviation: '5B',
      number: '16',
      order: 16,
      type: 'substitute',
    },
    {
      name: '6th Bench',
      abbreviation: '6B',
      number: '17',
      order: 17,
      type: 'substitute',
    },
    {
      name: '7th Bench',
      abbreviation: '7B',
      number: '18',
      order: 18,
      type: 'substitute',
    },
    {
      name: '8th Bench',
      abbreviation: '8B',
      number: '19',
      order: 19,
      type: 'substitute',
    },
    {
      name: '9th Bench',
      abbreviation: '9B',
      number: '20',
      order: 20,
      type: 'substitute',
    },
    {
      name: '10th Bench',
      abbreviation: '10B',
      number: '21',
      order: 21,
      type: 'substitute',
    },
    {
      name: '11th Bench',
      abbreviation: '11B',
      number: '22',
      order: 22,
      type: 'substitute',
    },
    {
      name: '12th Bench',
      abbreviation: '12B',
      number: '23',
      order: 23,
      type: 'substitute',
    },
  ]
},
{
  label: 'Futsal',
  positions: [
    {
      name: 'Goal Keeper',
      abbreviation: 'GK',
      number: '1',
      order: 1,
      type: 'line-up',
    },
    {
      name: 'Fixo',
      abbreviation: 'DEF',
      number: '2',
      order: 2,
      type: 'line-up',
    },
    {
      name: 'Ala',
      abbreviation: 'LW',
      number: '3',
      order: 3,
      type: 'line-up',
    },
    {
      name: 'Ala',
      abbreviation: 'RW',
      number: '4',
      order: 4,
      type: 'line-up',
    },
    {
      name: 'Target',
      abbreviation: 'PIVOT',
      number: '5',
      order: 5,
      type: 'line-up',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '6',
      order: 6,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '7',
      order: 7,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '8',
      order: 8,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '9',
      order: 9,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '10',
      order: 10,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '11',
      order: 11,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '12',
      order: 12,
      type: 'substitute',
    },
  ]
},
{
  label: 'Touch Football',
  positions: [
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '1',
      order: 1,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '2',
      order: 2,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '3',
      order: 3,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '4',
      order: 4,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '5',
      order: 5,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '6',
      order: 6,
      type: 'line-up',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '7',
      order: 7,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '8',
      order: 8,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '9',
      order: 9,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '10',
      order: 10,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '11',
      order: 11,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '12',
      order: 12,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '13',
      order: 13,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '14',
      order: 14,
      type: 'substitute',
    },
  ]
},
{
  label: 'Ultimate Frisbee',
  positions: [
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '1',
      order: 1,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '2',
      order: 2,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '3',
      order: 3,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '4',
      order: 4,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '5',
      order: 5,
      type: 'line-up',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '6',
      order: 6,
      type: 'line-up',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '7',
      order: 7,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '8',
      order: 8,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '9',
      order: 9,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '10',
      order: 10,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '11',
      order: 11,
      type: 'substitute',
    },
    {
      name: 'Substitute',
      abbreviation: 'SUB',
      number: '12',
      order: 12,
      type: 'substitute',
    },
  ]
},
{
  label: 'OzTag 6 Players',
  positions: [
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '1',
      order: 1,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '2',
      order: 2,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '3',
      order: 3,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '4',
      order: 4,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '5',
      order: 5,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '6',
      order: 6,
      type: 'line-up',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '1',
      order: 7,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '2',
      order: 8,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '3',
      order: 9,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '4',
      order: 10,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '5',
      order: 11,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '6',
      order: 12,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '7',
      order: 13,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '8',
      order: 14,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '9',
      order: 15,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '10',
      order: 16,
      type: 'substitute',
    },
  ]
},

{
  label: 'OzTag 7 Players',
  positions: [
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '1',
      order: 1,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '2',
      order: 2,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '3',
      order: 3,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '4',
      order: 4,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '5',
      order: 5,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '6',
      order: 6,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '7',
      order: 7,
      type: 'line-up',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '1',
      order: 8,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '2',
      order: 9,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '3',
      order: 10,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '4',
      order: 11,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '5',
      order: 12,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '6',
      order: 13,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '7',
      order: 14,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '8',
      order: 15,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '9',
      order: 16,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '10',
      order: 17,
      type: 'substitute',
    },
  ]
},

{
  label: 'OzTag 8 Players',
  positions: [
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '1',
      order: 1,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '2',
      order: 2,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '3',
      order: 3,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '4',
      order: 4,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '5',
      order: 5,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '6',
      order: 6,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '7',
      order: 7,
      type: 'line-up',
    },
    {
      name: 'Player',
      abbreviation: 'PL',
      number: '8',
      order: 8,
      type: 'line-up',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '1',
      order: 9,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '2',
      order: 10,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '3',
      order: 11,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '4',
      order: 12,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '5',
      order: 13,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '6',
      order: 14,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '7',
      order: 15,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '8',
      order: 16,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '9',
      order: 17,
      type: 'substitute',
    },
    {
      name: 'Reserve',
      abbreviation: 'RES',
      number: '10',
      order: 18,
      type: 'substitute',
    },
  ]
},
];

const allSizes = [
  {
    label: 'Kids',
    value: 'kids',
    options: [
      {
        label: 'Number',
        value: 'number',
        options: [
          {
            label: '6',
            value: 'kid-6',
          },
          {
            label: '8',
            value: 'kid-8',
          },
          {
            label: '10',
            value: 'kid-10',
          },
          {
            label: '12',
            value: 'kid-12',
          },
          {
            label: '14',
            value: 'kid-14',
          },
          {
            label: '16',
            value: 'kid-16',
          },
        ],
      },
      {
        label: 'Character',
        value: 'character',
        options: [
          {
            label: 'XS',
            value: 'kid-xs',
          },
          {
            label: 'S',
            value: 'kid-S',
          },
          {
            label: 'M',
            value: 'kid-M',
          },
          {
            label: 'L',
            value: 'kid-L',
          },
          {
            label: 'XL',
            value: 'kid-XL',
          },
          {
            label: 'XXL',
            value: 'kid-XXL',
          },
        ],
      },
    ]
  },
  {
    label: 'Mens',
    value: 'mens',
    options: [
      {
        label: 'Number',
        value: 'number',
        options: [
          {
            label: '6',
            value: 'mens-6',
          },
          {
            label: '8',
            value: 'mens-8',
          },
          {
            label: '10',
            value: 'mens-10',
          },
          {
            label: '12',
            value: 'mens-12',
          },
          {
            label: '14',
            value: 'mens-14',
          },
          {
            label: '16',
            value: 'mens-16',
          },
          {
            label: '18',
            value: 'mens-18',
          },
          {
            label: '20',
            value: 'mens-20',
          },
          {
            label: '22',
            value: 'mens-22',
          },
          {
            label: '24',
            value: 'mens-24',
          },
        ],
      },
      {
        label: 'Character',
        value: 'character',
        options: [
          {
            label: 'XS',
            value: 'mens-xs',
          },
          {
            label: 'Small',
            value: 'mens-s',
          },
          {
            label: 'Medium',
            value: 'mens-m',
          },
          {
            label: 'Large',
            value: 'mens-l',
          },
          {
            label: 'XL',
            value: 'mens-xl',
          },
          {
            label: '2XL',
            value: 'mens-2xl',
          },
          {
            label: '3XL',
            value: 'mens-3xl',
          },
          {
            label: '4XL',
            value: 'mens-4xl',
          },
          {
            label: '5XL',
            value: 'mens-5xl',
          },
          {
            label: '6XL',
            value: 'mens-6xl',
          },
        ],
      },
    ],
  },
  {
    label: 'Womens',
    value: 'womens',
    options: [
      {
        label: 'Number',
        value: 'number',
        options: [
          {
            label: '6',
            value: 'womens-6',
          },
          {
            label: '8',
            value: 'womens-8',
          },
          {
            label: '10',
            value: 'womens-10',
          },
          {
            label: '12',
            value: 'womens-12',
          },
          {
            label: '14',
            value: 'womens-14',
          },
          {
            label: '16',
            value: 'womens-16',
          },
          {
            label: '18',
            value: 'womens-18',
          },
          {
            label: '20',
            value: 'womens-20',
          },
          {
            label: '22',
            value: 'womens-22',
          },
          {
            label: '24',
            value: 'womens-24',
          },
        ],
      },
      {
        label: 'Character',
        value: 'character',
        options: [
          {
            label: 'XS',
            value: 'womens-xs',
          },
          {
            label: 'Small',
            value: 'womens-s',
          },
          {
            label: 'Medium',
            value: 'womens-m',
          },
          {
            label: 'Large',
            value: 'womens-l',
          },
          {
            label: 'XL',
            value: 'womens-xl',
          },
          {
            label: '2XL',
            value: 'womens-2xl',
          },
          {
            label: '3XL',
            value: 'womens-3xl',
          },
          {
            label: '4XL',
            value: 'womens-4xl',
          },
          {
            label: '5XL',
            value: 'womens-5xl',
          },
          {
            label: '6XL',
            value: 'womens-6xl',
          },
        ],
      },
    ]
  }
];

const periodTypes = [
  {
    label: 'N/A',
    value: 0
  },
  {
    label: 'Quarter',
    value: 4
  },
  {
    label: 'Half',
    value: 2
  },
  {
    label: 'Period',
    value: 1
  },
];

const timezones = [
  'Africa/Abidjan',
  'Africa/Accra',
  'Africa/Addis_Ababa',
  'Africa/Algiers',
  'Africa/Asmara',
  'Africa/Asmera',
  'Africa/Bamako',
  'Africa/Bangui',
  'Africa/Banjul',
  'Africa/Bissau',
  'Africa/Blantyre',
  'Africa/Brazzaville',
  'Africa/Bujumbura',
  'Africa/Cairo',
  'Africa/Casablanca',
  'Africa/Ceuta',
  'Africa/Conakry',
  'Africa/Dakar',
  'Africa/Dar_es_Salaam',
  'Africa/Djibouti',
  'Africa/Douala',
  'Africa/El_Aaiun',
  'Africa/Freetown',
  'Africa/Gaborone',
  'Africa/Harare',
  'Africa/Johannesburg',
  'Africa/Juba',
  'Africa/Kampala',
  'Africa/Khartoum',
  'Africa/Kigali',
  'Africa/Kinshasa',
  'Africa/Lagos',
  'Africa/Libreville',
  'Africa/Lome',
  'Africa/Luanda',
  'Africa/Lubumbashi',
  'Africa/Lusaka',
  'Africa/Malabo',
  'Africa/Maputo',
  'Africa/Maseru',
  'Africa/Mbabane',
  'Africa/Mogadishu',
  'Africa/Monrovia',
  'Africa/Nairobi',
  'Africa/Ndjamena',
  'Africa/Niamey',
  'Africa/Nouakchott',
  'Africa/Ouagadougou',
  'Africa/Porto-Novo',
  'Africa/Sao_Tome',
  'Africa/Timbuktu',
  'Africa/Tripoli',
  'Africa/Tunis',
  'Africa/Windhoek',
  'America/Adak',
  'America/Anchorage',
  'America/Anguilla',
  'America/Antigua',
  'America/Araguaina',
  'America/Argentina/Buenos_Aires',
  'America/Argentina/Catamarca',
  'America/Argentina/ComodRivadavia',
  'America/Argentina/Cordoba',
  'America/Argentina/Jujuy',
  'America/Argentina/La_Rioja',
  'America/Argentina/Mendoza',
  'America/Argentina/Rio_Gallegos',
  'America/Argentina/Salta',
  'America/Argentina/San_Juan',
  'America/Argentina/San_Luis',
  'America/Argentina/Tucuman',
  'America/Argentina/Ushuaia',
  'America/Aruba',
  'America/Asuncion',
  'America/Atikokan',
  'America/Atka',
  'America/Bahia',
  'America/Bahia_Banderas',
  'America/Barbados',
  'America/Belem',
  'America/Belize',
  'America/Blanc-Sablon',
  'America/Boa_Vista',
  'America/Bogota',
  'America/Boise',
  'America/Buenos_Aires',
  'America/Cambridge_Bay',
  'America/Campo_Grande',
  'America/Cancun',
  'America/Caracas',
  'America/Catamarca',
  'America/Cayenne',
  'America/Cayman',
  'America/Chicago',
  'America/Chihuahua',
  'America/Coral_Harbour',
  'America/Cordoba',
  'America/Costa_Rica',
  'America/Creston',
  'America/Cuiaba',
  'America/Curacao',
  'America/Danmarkshavn',
  'America/Dawson',
  'America/Dawson_Creek',
  'America/Denver',
  'America/Detroit',
  'America/Dominica',
  'America/Edmonton',
  'America/Eirunepe',
  'America/El_Salvador',
  'America/Ensenada',
  'America/Fort_Nelson',
  'America/Fort_Wayne',
  'America/Fortaleza',
  'America/Glace_Bay',
  'America/Godthab',
  'America/Goose_Bay',
  'America/Grand_Turk',
  'America/Grenada',
  'America/Guadeloupe',
  'America/Guatemala',
  'America/Guayaquil',
  'America/Guyana',
  'America/Halifax',
  'America/Havana',
  'America/Hermosillo',
  'America/Indiana/Indianapolis',
  'America/Indiana/Knox',
  'America/Indiana/Marengo',
  'America/Indiana/Petersburg',
  'America/Indiana/Tell_City',
  'America/Indiana/Vevay',
  'America/Indiana/Vincennes',
  'America/Indiana/Winamac',
  'America/Indianapolis',
  'America/Inuvik',
  'America/Iqaluit',
  'America/Jamaica',
  'America/Jujuy',
  'America/Juneau',
  'America/Kentucky/Louisville',
  'America/Kentucky/Monticello',
  ' America/Knox_IN',
  ' America/Kralendijk',
  ' America/La_Paz',
  ' America/Lima',
  ' America/Los_Angeles',
  ' America/Louisville',
  ' America/Lower_Princes',
  ' America/Maceio',
  ' America/Managua',
  ' America/Manaus',
  ' America/Marigot',
  ' America/Martinique',
  ' America/Matamoros',
  ' America/Mazatlan',
  ' America/Mendoza',
  ' America/Menominee',
  ' America/Merida',
  ' America/Metlakatla',
  ' America/Mexico_City',
  ' America/Miquelon',
  ' America/Moncton',
  ' America/Monterrey',
  ' America/Montevideo',
  'America/Montreal',
  'America/Montserrat',
  'America/Nassau',
  'America/New_York',
  'America/Nipigon',
  'America/Nome',
  'America/Noronha',
  'America/North_Dakota/Beulah',
  'America/North_Dakota/Center',
  'America/North_Dakota/New_Salem',
  'America/Ojinaga',
  'America/Panama',
  'America/Pangnirtung',
  'America/Paramaribo',
  'America/Phoenix',
  'America/Port-au-Prince',
  'America/Port_of_Spain',
  'America/Porto_Acre',
  'America/Porto_Velho',
  'America/Puerto_Rico',
  'America/Punta_Arenas',
  'America/Rainy_River',
  'America/Rankin_Inlet',
  'America/Recife',
  'America/Regina',
  'America/Resolute',
  'America/Rio_Branco',
  'America/Rosario',
  'America/Santa_Isabel',
  'America/Santarem',
  'America/Santiago',
  'America/Santo_Domingo',
  'America/Sao_Paulo',
  'America/Scoresbysund',
  'America/Shiprock',
  'America/Sitka',
  'America/St_Barthelemy',
  'America/St_Johns',
  'America/St_Kitts',
  'America/St_Lucia',
  'America/St_Thomas',
  'America/St_Vincent',
  'America/Swift_Current',
  'America/Tegucigalpa',
  'America/Thule',
  'America/Thunder_Bay',
  'America/Tijuana',
  'America/Toronto',
  'America/Tortola',
  'America/Vancouver',
  'America/Virgin',
  'America/Whitehorse',
  'America/Winnipeg',
  'America/Yakutat',
  'America/Yellowknife',
  'Antarctica/Casey',
  'Antarctica/Davis',
  'Antarctica/DumontDUrville',
  'Antarctica/Macquarie',
  'Antarctica/Mawson',
  'Antarctica/McMurdo',
  'Antarctica/Palmer',
  'Antarctica/Rothera',
  'Antarctica/South_Pole',
  'Antarctica/Syowa',
  'Antarctica/Troll',
  'Antarctica/Vostok',
  'Arctic/Longyearbyen',
  'Asia/Aden',
  'Asia/Almaty',
  'Asia/Amman',
  'Asia/Anadyr',
  'Asia/Aqtau',
  'Asia/Aqtobe',
  'Asia/Ashgabat',
  'Asia/Ashkhabad',
  'Asia/Atyrau',
  'Asia/Baghdad',
  'Asia/Bahrain',
  'Asia/Baku',
  'Asia/Bangkok',
  'Asia/Barnaul',
  'Asia/Beirut',
  'Asia/Bishkek',
  'Asia/Brunei',
  'Asia/Calcutta',
  'Asia/Chita',
  'Asia/Choibalsan',
  'Asia/Chongqing',
  'Asia/Chungking',
  'Asia/Colombo',
  'Asia/Dacca',
  'Asia/Damascus',
  'Asia/Dhaka',
  'Asia/Dili',
  'Asia/Dubai',
  'Asia/Dushanbe',
  'Asia/Famagusta',
  'Asia/Gaza',
  'Asia/Harbin',
  'Asia/Hebron',
  'Asia/Ho_Chi_Minh',
  'Asia/Hong_Kong',
  'Asia/Hovd',
  'Asia/Irkutsk',
  'Asia/Istanbul',
  'Asia/Jakarta',
  'Asia/Jayapura',
  'Asia/Jerusalem',
  'Asia/Kabul',
  'Asia/Kamchatka',
  'Asia/Karachi',
  'Asia/Kashgar',
  'Asia/Kathmandu',
  'Asia/Katmandu',
  'Asia/Khandyga',
  'Asia/Kolkata',
  'Asia/Krasnoyarsk',
  'Asia/Kuala_Lumpur',
  'Asia/Kuching',
  'Asia/Kuwait',
  'Asia/Macao',
  'Asia/Macau',
  'Asia/Magadan',
  'Asia/Makassar',
  'Asia/Manila',
  'Asia/Muscat',
  'Asia/Nicosia',
  'Asia/Novokuznetsk',
  'Asia/Novosibirsk',
  'Asia/Omsk',
  'Asia/Oral',
  'Asia/Phnom_Penh',
  'Asia/Pontianak',
  'Asia/Pyongyang',
  'Asia/Qatar',
  'Asia/Qyzylorda',
  'Asia/Rangoon',
  'Asia/Riyadh',
  'Asia/Saigon',
  'Asia/Sakhalin',
  'Asia/Samarkand',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Srednekolymsk',
  'Asia/Taipei',
  'Asia/Tashkent',
  'Asia/Tbilisi',
  'Asia/Tehran',
  'Asia/Tel_Aviv',
  'Asia/Thimbu',
  'Asia/Thimphu',
  'Asia/Tokyo',
  'Asia/Tomsk',
  'Asia/Ujung_Pandang',
  'Asia/Ulaanbaatar',
  'Asia/Ulan_Bator',
  'Asia/Urumqi',
  'Asia/Ust-Nera',
  'Asia/Vientiane',
  'Asia/Vladivostok',
  'Asia/Yakutsk',
  'Asia/Yangon',
  'Asia/Yekaterinburg',
  'Asia/Yerevan',
  'Atlantic/Azores',
  'Atlantic/Bermuda',
  'Atlantic/Canary',
  'Atlantic/Cape_Verde',
  'Atlantic/Faeroe',
  'Atlantic/Faroe',
  'Atlantic/Jan_Mayen',
  'Atlantic/Madeira',
  'Atlantic/Reykjavik',
  'Atlantic/South_Georgia',
  'Atlantic/St_Helena',
  'Atlantic/Stanley',
  'Australia/ACT',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Broken_Hill',
  'Australia/Canberra',
  'Australia/Currie',
  'Australia/Darwin',
  'Australia/Eucla',
  'Australia/Hobart',
  'Australia/LHI',
  'Australia/Lindeman',
  'Australia/Lord_Howe',
  'Australia/Melbourne',
  'Australia/NSW',
  'Australia/North',
  'Australia/Perth',
  'Australia/Queensland',
  'Australia/South',
  'Australia/Sydney',
  'Australia/Tasmania',
  'Australia/Victoria',
  'Australia/West',
  'Australia/Yancowinna',
  'Brazil/Acre',
  'Brazil/DeNoronha',
  'Brazil/East',
  'Brazil/West',
  'CET',
  'CST6CDT',
  'Canada/Atlantic',
  'Canada/Central',
  'Canada/Eastern',
  'Canada/Mountain',
  'Canada/Newfoundland',
  'Canada/Pacific',
  'Canada/Saskatchewan',
  'Canada/Yukon',
  'Chile/Continental',
  'Chile/EasterIsland',
  'Cuba',
  'EET',
  'EST',
  'EST5EDT',
  'Egypt',
  'Eire',
  'Etc/GMT',
  'Etc/GMT+0',
  'Etc/GMT+1',
  'Etc/GMT+10',
  'Etc/GMT+11',
  'Etc/GMT+12',
  'Etc/GMT+2',
  'Etc/GMT+3',
  'Etc/GMT+4',
  'Etc/GMT+5',
  'Etc/GMT+6',
  'Etc/GMT+7',
  'Etc/GMT+8',
  'Etc/GMT+9',
  'Etc/GMT-0',
  'Etc/GMT-1',
  'Etc/GMT-10',
  'Etc/GMT-11',
  'Etc/GMT-12',
  'Etc/GMT-13',
  'Etc/GMT-14',
  'Etc/GMT-2',
  'Etc/GMT-3',
  'Etc/GMT-4',
  'Etc/GMT-5',
  'Etc/GMT-6',
  'Etc/GMT-7',
  'Etc/GMT-8',
  'Etc/GMT-9',
  'Etc/GMT0',
  'Etc/Greenwich',
  'Etc/UCT',
  'Etc/UTC',
  'Etc/Universal',
  'Etc/Zulu',
  'Europe/Amsterdam',
  'Europe/Andorra',
  'Europe/Astrakhan',
  'Europe/Athens',
  'Europe/Belfast',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Bratislava',
  'Europe/Brussels',
  'Europe/Bucharest',
  'Europe/Budapest',
  'Europe/Busingen',
  'Europe/Chisinau',
  'Europe/Copenhagen',
  'Europe/Dublin',
  'Europe/Gibraltar',
  'Europe/Guernsey',
  'Europe/Helsinki',
  'Europe/Isle_of_Man',
  'Europe/Istanbul',
  'Europe/Jersey',
  'Europe/Kaliningrad',
  'Europe/Kiev',
  'Europe/Kirov',
  'Europe/Lisbon',
  'Europe/Ljubljana',
  'Europe/London',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Mariehamn',
  'Europe/Minsk',
  'Europe/Monaco',
  'Europe/Moscow',
  'Europe/Nicosia',
  'Europe/Oslo',
  'Europe/Paris',
  'Europe/Podgorica',
  'Europe/Prague',
  'Europe/Riga',
  'Europe/Rome',
  'Europe/Samara',
  'Europe/San_Marino',
  'Europe/Sarajevo',
  'Europe/Saratov',
  'Europe/Simferopol',
  'Europe/Skopje',
  'Europe/Sofia',
  'Europe/Stockholm',
  'Europe/Tallinn',
  'Europe/Tirane',
  'Europe/Tiraspol',
  'Europe/Ulyanovsk',
  'Europe/Uzhgorod',
  'Europe/Vaduz',
  'Europe/Vatican',
  'Europe/Vienna',
  'Europe/Vilnius',
  'Europe/Volgograd',
  'Europe/Warsaw',
  'Europe/Zagreb',
  'Europe/Zaporozhye',
  'Europe/Zurich',
  'GB',
  'GB-Eire',
  'GMT',
  'GMT+0',
  'GMT-0',
  'GMT0',
  'Greenwich',
  'HST',
  'Hongkong',
  'Iceland',
  'Indian/Antananarivo',
  'Indian/Chagos',
  'Indian/Christmas',
  'Indian/Cocos',
  'Indian/Comoro',
  'Indian/Kerguelen',
  'Indian/Mahe',
  'Indian/Maldives',
  'Indian/Mauritius',
  'Indian/Mayotte',
  'Indian/Reunion',
  'Iran',
  'Israel',
  'Jamaica',
  'Japan',
  'Kwajalein',
  'Libya',
  'MET',
  'MST',
  'MST7MDT',
  'Mexico/BajaNorte',
  'Mexico/BajaSur',
  'Mexico/General',
  'NZ',
  'NZ-CHAT',
  'Navajo',
  'PRC',
  'PST&PDT',
  'Pacific/Apia',
  'Pacific/Auckland',
  'Pacific/Bougainville',
  'Pacific/Chatham',
  'Pacific/Chuuk',
  'Pacific/Easter',
  'Pacific/Efate',
  'Pacific/Enderbury',
  'Pacific/Fakaofo',
  'Pacific/Fiji',
  'Pacific/Funafuti',
  'Pacific/Galapagos',
  'Pacific/Gambier',
  'Pacific/Guadalcanal',
  'Pacific/Guam',
  'Pacific/Honolulu',
  'Pacific/Johnston',
  'Pacific/Kiritimati',
  'Pacific/Kosrae',
  'Pacific/Kwajalein',
  'Pacific/Majuro',
  'Pacific/Marquesas',
  'Pacific/Midway',
  'Pacific/Nauru',
  'Pacific/Niue',
  'Pacific/Norfolk',
  'Pacific/Noumea',
  'Pacific/Pago_Pago',
  'Pacific/Palau',
  'Pacific/Pitcairn',
  'Pacific/Pohnpei',
  'Pacific/Ponape',
  'Pacific/Port_Moresby',
  'Pacific/Rarotonga',
  'Pacific/Saipan',
  'Pacific/Samoa',
  'Pacific/Tahiti',
  'Pacific/Tarawa',
  'Pacific/Tongatapu',
  'Pacific/Truk',
  'Pacific/Wake',
  'Pacific/Wallis',
  'Pacific/Yap',
  'Poland',
  'Portugal',
  'ROC',
  'ROK',
  'Singapore',
  'Turkey',
  'UCT',
  'US/Alaska',
  'US/Aleutian',
  'US/Arizona',
  'US/Central',
  'US/East-Indiana',
  'US/Eastern',
  'US/Hawaii',
  'US/Indiana-Starke',
  'US/Michigan',
  'US/Mountain',
  'US/Pacific',
  'US/Pacific-New',
  'US/Samoa',
  'UTC',
  'Universal',
  'W-SU',
  'WET',
  'Zulu',
];

module.exports = {
  errormsg,
  productTypes,
  genders,
  statuses,
  yesNoOptions,
  additionalQTypes,
  saleableItemTypes,
  matchStatus: matchStatus(),
  seasons,
  defaultSeason,
  finalTemplates,
  discountTypes,
  fileUploadAcceptString,
  states,
  uploadURL,
  countries,
  nationals,
  entityTypes,
  resultTypes,
  positionTypes,
  indvCompetitionTypes,
  posisitonPresets,
  allSizes,
  periodTypes,
  timezones,
  emailTemplateTypes
};
